import React, { useState, useEffect } from 'react';
import { Grid, TextField, Button, FormControl, InputLabel, Select, MenuItem, CircularProgress } from '@mui/material';
import { Search as SearchIcon, CleaningServices as CleaningServicesIcon, Add as AddIcon } from '@mui/icons-material';


function useDebounce(value, delay) {
    const [debouncedValue, setDebouncedValue] = useState(value);
    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedValue(value);
        }, delay);
        return () => {
            clearTimeout(handler);
        };
    }, [value, delay]);
    return debouncedValue;
}

export default function FiltrosBuscaFotos({ onSearch, onClear }) {

    const [filtros, setFiltros] = useState({
        nm_produto: '',
        cod_produto: '',
        status: '',
    });


    const debouncedFiltros = useDebounce(filtros, 500);

    useEffect(() => {
        // Dispara a busca apenas se o usuário preencheu algo
        const isFiltroPreenchido = Object.values(debouncedFiltros).some(v => v !== '');
        if (isFiltroPreenchido) {
            onSearch(debouncedFiltros);
        }
    }, [debouncedFiltros, onSearch]);

    const handleChange = (e) => {
        setFiltros(prev => ({ ...prev, [e.target.name]: e.target.value }));
    };

    const handleClearClick = () => {
        setFiltros({ nm_produto: '', cod_produto: '', status: '' });
        onClear();
    };

    return (
        <Grid container spacing={2} alignItems="center">
            <Grid item size={{ sx: 1, sm: 12, md: 4, lg: 4, xl: 1, xs: 12 }}>
                <TextField
                    fullWidth
                    name="nm_produto"
                    value={filtros.nm_produto}
                    onChange={handleChange}
                    label="Nome do Produto"
                    variant="outlined"
                    autoComplete="off"
                    InputProps={{
                        sx: { backgroundColor: 'white', color: 'black' }
                    }}
                    InputLabelProps={{
                        sx: { bgcolor: 'white', px: 0.5, color: 'black' }
                    }}
                />
            </Grid>
            <Grid item size={{ sx: 1, sm: 12, md: 4, lg: 4, xl: 1, xs: 12 }}>
                <TextField
                    fullWidth
                    name="cod_produto"
                    value={filtros.cod_produto}
                    onChange={handleChange}
                    label="Código do produto"
                    variant="outlined"
                    autoComplete="off"
                    InputProps={{
                        sx: { backgroundColor: 'white', color: 'black' }
                    }}
                    InputLabelProps={{
                        sx: { bgcolor: 'white', px: 0.5, color: 'black' }
                    }}
                />

            </Grid>
            <Grid item size={{ sx: 1, sm: 12, md: 4, lg: 4, xl: 1, xs: 12 }}>
                <TextField
                    select
                    fullWidth
                    name="status"
                    value={filtros.status} 
                    onChange={handleChange}
                    label="Status"
                    InputProps={{ sx: { backgroundColor: 'white', color: 'black' } }}
                    InputLabelProps={{ sx: { bgcolor: 'white', px: 0.5, color: 'black' } }}
                >
                    <MenuItem value="S">Ativo</MenuItem>
                    <MenuItem value="N">Inativo</MenuItem>
                </TextField>
            </Grid>
            <Grid container spacing={1} size={{ sx: 12, sm: 12, md: 12, lg: 12, xl: 12, xs: 12 }} justifyContent="flex-end">
                <Grid item>
                    <Button variant="outlined" onClick={handleClearClick} title="Limpar filtros">
                        <CleaningServicesIcon />
                    </Button>
                </Grid>
            </Grid>
        </Grid>
    );
}